const { canMergeCarts, mergeCarts } = require('@/lib/Cart/mergeCarts');
const { cloneDeep } = require('@/functions/clone');

/**
 * @param {StashedCart} stashedCartA
 * @param {StashedCart} stashedCartB
 *
 * @returns {Error|boolean}
 */
const canMergeStashedCarts = (stashedCartA, stashedCartB) => {
    return canMergeCarts(stashedCartA.currentCart, stashedCartB.currentCart, 'MERGE_CART');
};

/**
 * @param {StashedCart} stashedCartA
 * @param {StashedCart} stashedCartB
 *
 * @returns {StashedCart}
 */
const mergeStashedCarts = (stashedCartA, stashedCartB) => {
    // This doesn't run the canMergeStashedCarts check because it currently does the same thing as canMergeCarts,
    // which mergeCarts checks anyway. So there's no need to run it twice.
    // If canMergeStashedCarts is changed to check more things it should be run here.
    // let canMergeResult = canMergeStashedCarts(stashedCartA, stashedCartB);
    // if (canMergeResult instanceof Error) {
    //     throw canMergeResult;
    // }

    /**
     * @type {StashedCart}
     */
    const combinedStashedCart = cloneDeep(stashedCartA);

    combinedStashedCart.currentCart = mergeCarts(stashedCartA.currentCart, stashedCartB.currentCart);

    return combinedStashedCart;
};

module.exports = {
    canMergeStashedCarts,
    mergeStashedCarts,
};
